import "../styles/WhyUs.css";

export default function WhyUs() {
  return (
    <div className="why-us">
      <div className="why-item">
        <div className="why-icon">🐠</div>
        <h4>Fresh every morning</h4>
        <p>Straight from the Caribbean sea to your plate</p>
      </div>
      <div className="why-item">
        <div className="why-icon">🪸</div>
        <h4>Mangrove Tours</h4>
        <p>Explore the wild side of Roatan with us </p>
      </div>
      <div className="why-item">
        <div className="why-icon">👥</div>
        <h4>Tourists and locals</h4>
        <p>A place where everyone feels at home</p>
      </div>
      <div className="why-item">
        <div className="why-icon">🌐</div>
        <h4>English and Spanish</h4>
        <p>USD and Lempiras · No stress</p>
      </div>
    </div>
  );
}
